// extracted by mini-css-extract-plugin
export default {"button":"styles_button__A-j0g","editButton":"styles_editButton__250mx","deleteButton":"styles_deleteButton__WJv2l"};